import { AssetType } from '../../domain/models/asset-type.enum';
import { Asset } from '../../domain/models/asset.model';
import { TypeNode } from '../../domain/models/type-node.model';
import { TreeNode } from '../components/tree-view/tree-node.model';

export function assetToTreeNode(asset: Asset, isRoot = false): TreeNode {
  const loadedChildren = Array.from(asset.children);
  const hasUnloadedChildren =
    loadedChildren.length === 0 &&
    asset.metadata.properties?.['_hasChildren'] === true;

  // Build child nodes; prepend description leaf if present
  let children: TreeNode[] | undefined;
  if (loadedChildren.length > 0) {
    const childNodes: TreeNode[] = [];

    childNodes.push(...loadedChildren.map((c) => assetToTreeNode(c)));
    children = childNodes;
  } else if (hasUnloadedChildren) {
    children = [];
  }

  // Root label prefixed with entity type
  const label = isRoot
    ? `${asset.type !== AssetType.UNKNOWN ? asset.type.charAt(0).toUpperCase() + asset.type.slice(1) : 'Asset'}: ${asset.name}`
    : asset.name;

  return {
    value: asset.id,
    label,
    children,
  };
}

export function typeNodeToTreeNode(
  typeNode: TypeNode,
  isRoot = false,
): TreeNode {
  const children = Array.from(typeNode.children);
  return {
    value: typeNode.getId(),
    label: typeNode.label,
    isRoot,
    isRelationship: typeNode.isRelationshipNode,
    children: children.length
      ? children.map((c) => typeNodeToTreeNode(c))
      : undefined,
  };
}
